module.exports = __webpack_public_path__ + "img/bullet_7.01608f17.svg";